<template>
  <div class="pa-8 pb-2 pt-7">
    <v-container grid-list-xl fluid class="pa-0 px-1">
      <v-layout row wrap class="pr-2 pl-2">
        <v-alert dense dismissible color="#6A7589" width="100%" dark>
          <img
            src="@/assets/images/icon/info.png"
            class="vertical-align-middle"
            width="20px"
          />
          <span class="vertical-align-middle fs-14">
            Notes: Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
            do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
            enim ad minim veniam.
          </span>
        </v-alert>
        <v-flex xs12 sm8 md8 lg8 mb-3 class="pb-0 pa-0">
          <h3 class="pt-4 breadcrumbs font-weight-700 fs-16 lh-16">
            A&P OVERVIEW
          </h3>
        </v-flex>
        <v-spacer></v-spacer>
        <advance-filter
          v-if="!isLoggedInAsBO"
          title="dashboard"
          :isDownload="false"
          @getFiltered="getFiltered"
          class="pt-0"
        />
        <date-picker
          v-model="year"
          type="year"
          placeholder="Year"
          format="YYYY"
          class="dashSearch filterSearch mt-2"
          style="width: 75px !important"
        >
        </date-picker>
      </v-layout>
      <v-layout
        row
        wrap
        class="pa-0 grey--text font-weight-500 fs-12 lh-16 mt-0 pr-2 pl-2"
      >
        <v-expansion-panels flat class="filterby-info">
          <v-expansion-panel>
            <v-expansion-panel-header
              class="primary--text fs-13 px-0 pt-0 pb-1 secondary"
              height="100px"
            >
              Filter By Information
            </v-expansion-panel-header>
            <v-expansion-panel-content class="grey--text secondary">
              <ul v-if="filterBy.length > 0">
                <li
                  v-for="(filter, indexFilter) in filterBy"
                  :key="'filter' + indexFilter"
                  class="text-left"
                >
                  {{ yearInfo }}
                  <template v-for="(detail, indexDetail) in filter">
                    {{ ' / ' }}
                    <span :key="'indexDetail-' + indexDetail">
                      {{ detail.map(e => e.name).join(' / ') }}
                    </span>
                  </template>
                </li>
              </ul>
              <ul v-else>
                <li>{{ yearInfo }}</li>
              </ul>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-layout>
    </v-container>
    <v-flex xs12 class="pa-0 mt-2">
      <v-layout row wrap class="spending-info pa-0 mb-0">
        <!-- card amount -->
        <v-row class="mx--1">
          <v-col cols="12" sm="6" md="3">
            <card-amount
              colour="softGreen"
              :typeCard="1"
              text="BUDGET"
              :value1="Number(item.totalBudget)"
              :valueEur="Number(item.totalBudgetEur)"
              textColor="softGreen--text"
              :isLoad="isLoadSummary"
            ></card-amount>
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <card-amount
              colour="softRed"
              :typeCard="2"
              text="SPENDING IO"
              :value1="Number(item.totalSpending)"
              :valueEur="Number(item.totalSpendingEur)"
              :valuePercent="itemPercent.spending"
              textColor="softRed--text"
              :isLoad="isLoadSummary"
            ></card-amount>
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <card-amount
              colour="blueCloud"
              :typeCard="3"
              text="PO & Non-PO"
              :value1="Number(item.totalPO)"
              :valueEur="Number(item.totalPOEur)"
              :valuePercent="itemPercent.po"
              textColor="blueCloud--text"
              :isLoad="isLoadSummary"
            ></card-amount>
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <card-amount
              colour="lime"
              :typeCard="4"
              text="GR & ACTUAL"
              :value1="Number(item.totalGR)"
              :valueEur="Number(item.totalGREur)"
              :valuePercent="itemPercent.gr"
              textColor="orange--text"
              :isLoad="isLoadSummary"
            ></card-amount>
          </v-col>
        </v-row>
        <!-- spending chart -->
        <v-flex xs12 class="px-3 mt-2 mb-3">
          <v-card class="elevation-card">
            <v-card-title class="pa-3" style="border-bottom: 2px solid #d8d8d8">
              <v-row dense align="center" class="px-3">
                <v-col cols="8" class="pl-3">
                  <h5 class="primary--text pa-0 ma-0 font-weight-bold">
                    {{ thisYear }} SPENDING
                  </h5>
                  <h2
                    class="mt-0 pt-0 greylight--text fs-12 lh-6 font-weight-500"
                  >
                    By {{ filter }}
                  </h2>
                </v-col>
                <v-spacer></v-spacer>
                <v-menu :absolute="false">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      color="grey"
                      style="font-size: 13pt !important"
                      v-bind="attrs"
                      v-on="on"
                      class="mr-3"
                    >
                      ri-settings-2-line
                    </v-icon>
                  </template>
                  <v-list>
                    <v-list-item
                      v-for="(item, index) in filters"
                      :key="index"
                      @click="changeFilter(year, item)"
                    >
                      <v-list-item-title>
                        {{ item.name }}
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
                <v-menu
                  :absolute="false"
                  top
                  :close-on-content-click="false"
                  offset-y
                  v-if="filter === 'Budget Owner'"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      color="grey"
                      style="font-size: 13pt !important"
                      v-bind="attrs"
                      v-on="on"
                      small
                      class="mr-3"
                    >
                      mdi-chevron-down
                    </v-icon>
                  </template>
                  <v-card class="pa-4">
                    <h2 class="greylight--text mb-2 body-2">
                      Select to Hide or Show Data
                    </h2>
                    <v-chip
                      v-for="(label, index) in boData"
                      :key="index"
                      small
                      :color="label.show ? '#8ca8d1' : '#d1dced'"
                      class="mr-1 mb-1 white--text"
                      :class="label.show ? '' : 'text-strike'"
                      @click="hideDataStacked(label, index)"
                    >
                      {{ label.name }}
                    </v-chip>
                  </v-card>
                </v-menu>
                <v-menu
                  :absolute="false"
                  top
                  :close-on-content-click="false"
                  offset-y
                  v-else
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      color="grey"
                      style="font-size: 13pt !important"
                      v-bind="attrs"
                      v-on="on"
                      small
                      class="mr-3"
                    >
                      mdi-chevron-down
                    </v-icon>
                  </template>
                  <v-card class="pa-4">
                    <h2 class="greylight--text mb-2 body-2">
                      Select to Hide or Show Data
                    </h2>
                    <v-chip
                      v-for="(label, index) in legendChart"
                      :key="index"
                      small
                      :color="label.show ? '#8ca8d1' : '#d1dced'"
                      class="mr-1 mb-1 white--text"
                      :class="label.show ? '' : 'text-strike'"
                      @click="hideData(label, index)"
                    >
                      {{ label.name }}
                    </v-chip>
                  </v-card>
                </v-menu>
              </v-row>
            </v-card-title>
            <!-- <hr class="hr-line-strip" /> -->
            <v-card-text class="pt-5">
              <v-row class="my-3 mb-0">
                <v-flex xs12 class="pa-0" v-if="isLoadChartBar">
                  <v-skeleton-loader
                    type="paragraph"
                    class="ml-5"
                  ></v-skeleton-loader>
                </v-flex>
                <v-flex xs12 class="pa-0" v-else>
                  <apexchart
                    v-if="filter === 'Budget Owner'"
                    class="pr-3 pl-6 pb-2"
                    style=""
                    type="bar"
                    :height="350"
                    :options="chartOptionsStacked"
                    :series="seriesStacked"
                  ></apexchart>
                  <apexchart
                    v-if="filter === 'Taxonomy'"
                    class="pr-3 pl-6 pb-2"
                    style=""
                    type="bar"
                    :height="350"
                    :options="chartOptionsTaxo"
                    :series="seriesTaxo"
                    @dataPointSelection="selectionChart"
                  ></apexchart>
                  <apexchart
                    v-if="filter === 'Cost Center'"
                    class="pr-3 pl-6 pb-2"
                    style=""
                    type="bar"
                    :height="350"
                    :options="chartOptionsTaxo"
                    :series="seriesTaxo"
                  ></apexchart>
                </v-flex>
              </v-row>
            </v-card-text>
          </v-card>
        </v-flex>
        <!-- calendar chart -->
        <!-- <v-flex xs12 class="px-3 mt-2 mb-3">
          <v-card class=" elevation-card">
            <v-card-title class="pa-3">
              <v-layout row wrap class="px-3">
                <div>
                  <img
                    src="@/assets/images/icon/calendar.png"
                    width="35px"
                    class="mt-2"
                  />
                </div>
                <v-flex xs8 sm8 md8 lg8 class="pl-3">
                  <h5 class="primary--text pa-0 ma-0 font-weight-bold">
                    {{ thisYear }} CALENDAR
                  </h5>
                  <h2
                    class="mt-0 pt-0 greylight--text fs-12 lh-6 font-weight-500"
                  >
                    Activity by {{ filterCalendar }}
                  </h2>
                </v-flex>
                <v-spacer></v-spacer>
                <v-menu
                  :absolute="false"
                  top
                  :close-on-content-click="false"
                  offset-y
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      color="grey"
                      style="font-size: 20pt !important"
                      v-bind="attrs"
                      v-on="on"
                      class="mr-3"
                    >
                      filter_list
                    </v-icon>
                  </template>
                  <v-card class="pa-4">
                    <h2 class="greylight--text mb-2 body-2">
                      Select to Hide or Show Data
                    </h2>
                    <v-chip
                      v-for="(label, index) in labelCalendar"
                      :key="index"
                      small
                      :color="label.show ? '#8ca8d1' : '#d1dced'"
                      class="mr-1 mb-1 white--text"
                      :class="label.show ? '' : 'text-strike'"
                      @click="hideDataCalendar(label, index)"
                    >
                      {{ label.name }}
                    </v-chip>
                  </v-card>
                </v-menu>
                <v-menu :absolute="false">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      color="grey"
                      style="font-size: 17pt !important"
                      v-bind="attrs"
                      v-on="on"
                      class="mr-3"
                    >
                      settings
                    </v-icon>
                  </template>
                  <v-list>
                    <v-list-item
                      v-for="(item, index) in calendarFilters"
                      :key="index"
                      @click="getCalendar(item)"
                    >
                      <v-list-item-title>
                        {{ item.name }}
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-layout>
            </v-card-title>
            <v-card-text class="pt-5" style="border-top: 2px solid #d8d8d8;">
              <apexchart
                type="rangeBar"
                height="350"
                :options="chartOptionsCalendar"
                :series="seriesCalendar"
              ></apexchart>
              <v-layout class="timeline">
                <v-flex xs2 class="text-center timeline-calendar q1">
                  <ul>
                    <li><span>Q1</span></li>
                  </ul>
                </v-flex>
                <v-flex xs2 class="text-center timeline-calendar q2">
                  <ul>
                    <li><span>Q2</span></li>
                  </ul>
                </v-flex>
                <v-flex xs2 class="text-center timeline-calendar q3">
                  <ul>
                    <li><span>Q3</span></li>
                  </ul>
                </v-flex>
                <v-flex xs2 class="text-center timeline-calendar q4">
                  <ul>
                    <li><span>Q4</span></li>
                  </ul>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex> -->
        <v-flex xs12 sm6 md6 lg6 class="px-3 my-3">
          <v-card class="elevation-card">
            <!-- <v-skeleton-loader
                    type="paragraph"
                    class="ml-5"
                    v-if="isLoadChartBar"
                  ></v-skeleton-loader> -->
            <v-row>
              <v-flex xs6 pa-3>
                <v-flex xs12 class="mb-2">
                  <v-row class="pl-4">
                    <div>
                      <span
                        class="
                                mt-0
                                pt-0
                                primary--text
                                pl-1
                                pb-1
                                fs-12
                              "
                      >
                        <b>By Working/Non Working</b>
                      </span>
                    </div>
                    <v-spacer></v-spacer>
                    <v-menu
                      :absolute="false"
                      top
                      :close-on-content-click="false"
                      offset-y
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          class="mr-7"
                          color="grey"
                          style="font-size: 13pt !important"
                          v-bind="attrs"
                          v-on="on"
                        >
                          mdi-chevron-down
                        </v-icon>
                      </template>
                      <v-card class="pa-4">
                        <h2 class="greylight--text mb-2 body-2">
                          Select to Hide or Show Data
                        </h2>
                        <v-chip
                          v-for="(label, index) in legendPillar"
                          :key="index"
                          small
                          :color="label.show ? '#57abff' : '#98c7f7'"
                          class="mr-1 mb-1 white--text"
                          :class="label.show ? '' : 'text-strike'"
                          @click="hideDataPillar(label, index)"
                        >
                          {{ label.name }}
                        </v-chip>
                      </v-card>
                    </v-menu>
                  </v-row>
                </v-flex>
                <v-flex xs12>
                  <apexchart
                    type="donut"
                    width="100%"
                    height="250px"
                    :options="chartOptionsPillar"
                  ></apexchart>
                </v-flex>
              </v-flex>
              <v-flex xs6 pa-3>
                <v-flex xs12 class="mb-2">
                  <v-row class="pl-2">
                    <div>
                      <span
                        class="
                                mt-0
                                pt-0
                                primary--text
                                fs-12
                                pl-1
                                pb-1
                              "
                      >
                        <b>By Method</b>
                      </span>
                    </div>
                    <v-spacer></v-spacer>
                    <v-menu
                      :absolute="false"
                      top
                      :close-on-content-click="false"
                      offset-y
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          class="mr-7"
                          color="grey"
                          style="font-size: 20pt !important"
                          v-bind="attrs"
                          v-on="on"
                        >
                          mdi-chevron-down
                        </v-icon>
                      </template>
                      <v-card class="pa-4">
                        <h2 class="greylight--text mb-2 body-2">
                          Select to Hide or Show Data
                        </h2>
                        <v-chip
                          v-for="(label, index) in legendMethod"
                          :key="index"
                          small
                          :color="label.show ? '#57abff' : '#98c7f7'"
                          class="mr-1 mb-1 white--text"
                          :class="label.show ? '' : 'text-strike'"
                          @click="hideDataMethod(label, index)"
                        >
                          {{ label.name }}
                        </v-chip>
                      </v-card>
                    </v-menu>
                  </v-row>
                </v-flex>
                <apexchart
                  type="donut"
                  width="100%"
                  height="250px"
                  :options="chartOptionsMethod"
                ></apexchart>
              </v-flex>
            </v-row>
          </v-card>
        </v-flex>
        <v-flex xs12 sm6 md6 lg6 class="px-3 my-3">
          <v-card class="elevation-card pt-3">
            <v-flex xs12 class="mb-2">
              <v-row class="pl-5">
                <div>
                  <span
                    class="
                            mt-0
                            pt-0
                            primary--text
                            fs-12
                            pl-1
                            pb-1
                          "
                  >
                    <b>By Quarter</b>
                  </span>
                </div>
                <v-spacer></v-spacer>
                <v-menu
                  :absolute="false"
                  top
                  :close-on-content-click="false"
                  offset-y
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      class="mr-7"
                      color="grey"
                      style="font-size: 20pt !important"
                      v-bind="attrs"
                      v-on="on"
                    >
                      mdi-chevron-down
                    </v-icon>
                  </template>
                  <v-card class="pa-4">
                    <h2 class="greylight--text mb-2 body-2">
                      Select to Hide or Show Data
                    </h2>
                    <v-chip
                      v-for="(label, index) in legendQuarter"
                      :key="index"
                      small
                      :color="label.show ? '#57abff' : '#98c7f7'"
                      class="mr-1 mb-1 white--text"
                      :class="label.show ? '' : 'text-strike'"
                      @click="hideDataQuarter(label, index)"
                    >
                      {{ label.name }}
                    </v-chip>
                  </v-card>
                </v-menu>
              </v-row>
            </v-flex>
            <v-flex xs12 class="pa-0" v-if="isLoadQuarter">
              <v-skeleton-loader
                type="paragraph"
                class="ml-5"
              ></v-skeleton-loader>
            </v-flex>
            <apexchart
              v-else
              type="bar"
              height="235px"
              class="pl-3"
              :options="chartOptions"
              :series="series"
              style="margin-top: -20px"
            ></apexchart>
          </v-card>
        </v-flex>
        <!-- roi chart -->
        <v-flex xs12 sm6 md6 lg6 class="px-3 mt-3">
          <v-card class=" elevation-card">
            <v-card-title class="pa-3" style="">
              <v-layout row wrap class="px-3">
                <v-flex xs8 sm8 md8 lg8 class="pl-3">
                  <h5 class="primary--text pa-0 ma-0 font-weight-bold">
                    ROI & KPI MONITORING
                  </h5>
                  <h2
                    class="mt-0 pt-0 greylight--text fs-12 lh-6 font-weight-500"
                  >
                    By Activity & Campaign
                  </h2>
                </v-flex>
                <v-spacer></v-spacer>
              </v-layout>
            </v-card-title>
            <v-card-text class="pt-2" style="height: 300px">
              <!-- <v-flex xs12 class=" mb-2">
                <v-row class="pl-2">
                  <div>
                    <span
                      class="mt-0 pt-0 greylight--text body-1 pl-1 pb-1 verLine-teal"
                    >
                      <b>By {{ filter }}</b>
                    </span>
                  </div>
                </v-row>
              </v-flex> -->
              <h2
                v-if="
                  key_highlight.length === 0 && keyHighlightSystem.length === 0
                "
                class="grey--text text-center my-10 py-5"
              >
                Coming Soon
              </h2>
              <h2 v-else class="grey--text text-center title-comingsoon">
                Coming Soon
              </h2>
            </v-card-text>
          </v-card>
        </v-flex>
        <!-- Key highlight -->
        <v-flex xs12 sm6 md6 lg6 class="px-3 mt-3">
          <v-card class=" elevation-card key-highlight">
            <v-card-title class="pa-3" style="">
              <v-layout row wrap class="px-3">
                <v-flex xs8 sm8 md8 lg8 class="pl-3">
                  <h5 class="primary--text pa-0 ma-0 font-weight-bold">
                    KEY HIGHLIGHT
                  </h5>
                  <h2
                    class="mt-0 pt-0 greylight--text fs-12 lh-6 font-weight-500"
                  >
                    To Do & Information
                  </h2>
                </v-flex>
                <v-spacer></v-spacer>
                <!-- <v-menu :absolute="false">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      color="grey"
                      style="font-size: 17pt !important"
                      v-bind="attrs"
                      v-on="on"
                      class="mr-3"
                    >
                      settings
                    </v-icon>
                  </template>
                  <v-list>
                    <v-list-item>
                      <v-list-item-title>
                        setting
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu> -->
              </v-layout>
            </v-card-title>
            <v-skeleton-loader
              type="paragraph"
              class="ml-5"
              v-if="isLoadHightlight"
            ></v-skeleton-loader>
            <VuePerfectScrollbar
              class="drawer-menu--scroll"
              :settings="scrollSettings"
              v-else
            >
              <v-card-text class="pt-2" style="height: 300px">
                <v-row
                  no-gutters
                  v-if="
                    key_highlight.length > 0 || keyHighlightSystem.length > 0
                  "
                >
                  <v-col
                    v-if="keyHighlightSystem.length > 0"
                    cols="12"
                    :lg="key_highlight.length > 0 ? '6' : '12'"
                    class="pr-2"
                  >
                    <v-list>
                      <template v-for="item in keyHighlightSystem">
                        <v-list-item
                          class="px-0"
                          :key="'highlightSystemlist' + item.id"
                        >
                          <v-list-item-action>
                            <div class="circle-icon pa-2">
                              <v-icon color="white">mdi-calendar</v-icon>
                            </div>
                          </v-list-item-action>
                          <v-list-item-content>
                            <v-list-item-title>
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                  <span v-on="on">{{ item.message }}</span>
                                </template>
                                <span>{{ item.message }}</span>
                              </v-tooltip>
                            </v-list-item-title>
                            <v-list-item-subtitle>
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                  <span v-on="on">
                                    {{ formatDateTime(item.created_at) }}
                                  </span>
                                </template>
                                <span>
                                  {{ formatDateTime(item.created_at) }}
                                </span>
                              </v-tooltip>
                            </v-list-item-subtitle>
                          </v-list-item-content>
                          <v-list-item-action>
                            <v-chip dark color="#fc8027" small>
                              {{ item.type_msg }}
                            </v-chip>
                          </v-list-item-action>
                        </v-list-item>
                        <v-divider
                          class="divider-small"
                          :key="'highlightSystem' + item.id"
                          inset
                        />
                      </template>
                    </v-list>
                  </v-col>
                  <v-col
                    v-if="key_highlight.length > 0"
                    cols="12"
                    :lg="keyHighlightSystem.length > 0 ? '6' : '12'"
                    class="pr-2"
                  >
                    <v-list>
                      <template v-for="val in key_highlight">
                        <v-list-item class="px-0" :key="'highlight' + val.id">
                          <v-list-item-action>
                            <div class="circle-icon-2 pa-2">
                              <v-icon color="white">mdi-calendar</v-icon>
                            </div>
                          </v-list-item-action>
                          <v-list-item-content>
                            <v-list-item-title>
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                  <span v-on="on">{{ val.message }}</span>
                                </template>
                                <span>{{ val.message }}</span>
                              </v-tooltip>
                            </v-list-item-title>
                            <v-list-item-subtitle>
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                  <span v-on="on">{{ val.date }}</span>
                                </template>
                                <span>{{ val.date }}</span>
                              </v-tooltip>
                            </v-list-item-subtitle>
                          </v-list-item-content>
                          <v-list-item-action>
                            <v-chip dark color="#00B5B8" small>Reminder</v-chip>
                          </v-list-item-action>
                        </v-list-item>
                        <v-divider
                          class="divider-small"
                          :key="'msg' + val.id"
                          inset
                        />
                      </template>
                    </v-list>
                  </v-col>
                </v-row>
                <h2 class="grey--text text-center my-10 py-5" v-else>
                  No Data Available
                </h2>
              </v-card-text>
            </VuePerfectScrollbar>
          </v-card>
        </v-flex>
      </v-layout>
    </v-flex>
    <progress-dialog :show="progressDialogLoading" text="Please wait">
    </progress-dialog>
  </div>
</template>

<script>
import ProgressDialog from '../components/progress_dialog';
import moment from 'moment';
import Swal from 'sweetalert2';
import ApexCharts from 'apexcharts';
import cardDashboard from '../components/AmountDash';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import ACLMixin from '../mixins/ACLMixin';
import advanceFilter from '../components/advanceFilter/DynamicFilter';

export default {
  components: {
    'progress-dialog': ProgressDialog,
    VuePerfectScrollbar,
    'card-amount': cardDashboard,
    'advance-filter': advanceFilter
  },
  mixins: [ACLMixin],
  data() {
    return {
      isLoadSummary: false,
      isLoadChartBar: false,
      isLoadStackedChart: false,
      isLoadQuarter: false,
      isLoadHightlight: false,
      scrollSettings: {
        maxScrollbarLength: 260
      },
      progressDialogLoading: false,
      loading: true,
      isDisabledHouse: false,
      isDisabledDept: false,
      isDisabledBo: false,
      showFilterDialog: false,
      filterBy: '',
      year: new Date(),
      showYear: moment(new Date()).format('YYYY'),
      item: {},
      itemPercent: {},
      thisYear: new Date(),
      filters: [
        {
          name: 'Taxonomy',
          value: 'taxo'
        },
        {
          name: 'Cost Center',
          value: 'cost_center'
        },
        {
          name: 'Budget Owner',
          value: 'budget_owner'
        }
      ],
      calendarFilters: [
        {
          name: 'Taxonomy',
          value: 'taxo'
        },
        {
          name: 'Cost Center',
          value: 'cost_center'
        }
      ],
      filterCalendar: 'Taxonomy',
      taxoData: [],
      taxoLabel: [],
      legendChart: [],
      quarterData: [],
      quarterLabel: [],
      quarterPercent: [],
      legendQuarter: [],
      pillarData: [],
      pillarLabel: [],
      pillarPercent: [],
      legendPillar: [],
      methodData: [],
      methodLabel: [],
      methodPercent: [],
      legendMethod: [],
      roiData: [57, 43],
      roiLabel: ['Digital', ''],
      averageData: [50, 50],
      averageLabel: ['Average', ''],
      minData: [37, 63],
      minLabel: ['Min', ''],
      maxData: [80, 20],
      maxLabel: ['Max', ''],
      filter: 'Taxonomy',
      divisionFil: [],
      isDivision: true,
      houseFil: [],
      isHouse: true,
      deptFil: [],
      isDept: true,
      boFil: [],
      isBo: true,
      divisionList: [],
      houseList: [],
      deptList: [],
      boList: [],
      dataCalendar: [],
      labelCalendar: [],
      timeout: null,
      colors: ['#5273E8', '#FA576E', '#66C7FF', '#FC9A27'],
      profile_id: null,
      key_highlight: [],
      keyHighlightSystem: [],
      boData: [],
      boLabel: [],
      divId: [],
      groupId: [],
      boId: [],
      paramFiltered: [
        {
          divisionIds: [],
          houseIds: [],
          groupIds: [],
          budgetOwnerIds: []
        }
      ]
    };
  },
  async mounted() {
    let menu = JSON.parse(localStorage.getItem('menu'));
    let hasDashboard = menu.some(val => val.name === 'dashboard');
    if (hasDashboard) {
      this.thisYear = moment(this.year).format('YYYY');
      this.profile_id = localStorage.getItem('profile_id');
      await this.getData(this.year);
      await this.getReminderBudget();
    }
  },
  watch: {
    // 'dataCalendar.length'(val) {
    //   let height = '';
    //   if (val < 50) {
    //    return '350;
    //   } else if (val > 50 && val < 100) {
    //     height = '400';
    //   } else if (val > 100) {
    //     height = 'auto';
    //   }
    //   ApexCharts.exec('calendarChart', 'updateOptions', {
    //     xaxis: {
    //       type: 'datetime',
    //       min: new Date('Jan').getTime(),
    //       max: new Date('Dec').getTime(),
    //       labels: {
    //         datetimeFormatter: {
    //           month: 'MMM'
    //         }
    //       }
    //     },
    //     chart: {
    //       height: height
    //     }
    //   });
    // },
    year(val) {
      this.getData(val);
      this.thisYear = moment(val).format('YYYY');
    }
  },
  computed: {
    yearInfo() {
      return moment(this.year).format('YYYY');
    },
    series: function() {
      return [
        {
          name: 'Spending',
          data: this.quarterData.reduce(function(filtered, option) {
            if (option.show) {
              // var someNewValue = (Math.abs(option.name) / 1000000000).toFixed(
              //   1
              // );
              filtered.push(option.name);
            }
            return filtered;
          }, [])
        }
      ];
    },
    chartOptions: function() {
      return {
        chart: {
          id: 'quarterChart',
          height: 220,
          type: 'bar',
          toolbar: {
            show: false
          }
        },
        colors: ['#FF8B49'],
        plotOptions: {
          radius: 15,
          bar: {
            borderRadius: 10,

            dataLabels: {
              position: 'top' // top, center, bottom
            },
            columnWidth: '50%'
          }
        },
        percent: this.quarterPercent.reduce(function(filtered, option) {
          if (option.show) {
            var someNewValue = option.name;
            filtered.push(someNewValue);
          }
          return filtered;
        }, []),
        dataLabels: {
          enabled: true,
          borderRadius: 15,
          formatter: function(val, { dataPointIndex, w }) {
            let value = (Math.abs(val) / 1000000000).toFixed(1);
            return `${value} (${w.config.percent[dataPointIndex]}%)`;
          },
          offsetY: -20,
          style: {
            fontSize: '12px',
            colors: ['#304758']
          }
        },
        xaxis: {
          lines: {
            show: true
          },
          categories: this.quarterLabel.reduce(function(filtered, option) {
            if (option.show) {
              var someNewValue = '';
              if (option.name.length > 13) {
                someNewValue = option.name.slice(0, 1) + '..';
              } else if (option.name.length <= 13) {
                someNewValue = option.name;
              }
              filtered.push(someNewValue.toUpperCase());
            }
            return filtered;
          }, []),
          position: 'bottom',
          labels: {
            offsetY: 0
          },
          axisBorder: {
            show: true
          },
          axisTicks: {
            show: false
          },
          crosshairs: {
            fill: {
              type: 'gradient',
              gradient: {
                colorFrom: '#57abff',
                colorTo: '#57abff',
                stops: [0, 100],
                opacityFrom: 0.4,
                opacityTo: 0.5
              }
            }
          },
          tooltip: {
            enabled: false,
            offsetY: -35
          }
        },
        fill: {
          gradient: {
            shade: 'light',
            type: 'horizontal',
            shadeIntensity: 0.25,
            gradientToColors: undefined,
            inverseColors: true,
            opacityFrom: 1,
            opacityTo: 1,
            stops: [50, 0, 100, 100]
          }
        },
        yaxis: {
          lines: {
            show: true
          },
          axisBorder: {
            show: true
          },
          axisTicks: {
            show: false
          },
          title: {
            text: 'in BIDR'
          },
          labels: {
            show: true,
            formatter: function(val) {
              let value = (Math.abs(val) / 1000000000).toFixed(1);
              return value;
            }
          }
        },
        grid: {
          show: false
        },
        title: {
          text: '',
          floating: false,
          offsetY: 320,
          align: 'center',
          style: {
            color: '#444'
          }
        }
      };
    },
    seriesTaxo: function() {
      return [
        {
          name: 'Total IO',
          data: this.taxoData.reduce(function(filtered, option) {
            if (option.show) {
              // var someNewValue = (Math.abs(option.total) / 1000000000).toFixed(
              //   1
              // );
              filtered.push(option.total);
            }
            return filtered;
          }, [])
        }
      ];
    },
    chartOptionsTaxo: function() {
      return {
        chart: {
          id: 'taxoChart',
          height: 350,
          type: 'bar',
          stacked: true,
          toolbar: {
            show: false
          }
          // events: {
          //   dataPointSelection: function(event, chartContext, config) {
          //     // ...
          //     this.$router.push({
          //       // params: { id: value },
          //       name: 'spending'
          //     });
          //   }
          // }
        },
        colors: ['#28A0F6'],
        plotOptions: {
          bar: {
            borderRadius: 10,
            dataLabels: {
              position: 'top'
            }
          }
        },
        dataLabels: {
          enabled: true,
          borderRadius: 15,
          formatter: function(val) {
            let value = (Math.abs(val) / 1000000000).toFixed(1);
            return `${value}`;
          },
          offsetY: -25,
          style: {
            fontSize: '12px',
            colors: ['#304758']
          }
        },
        xaxis: {
          categories: this.taxoLabel.reduce(function(filtered, option) {
            if (option.show) {
              var someNewValue = '';
              someNewValue = option.name;
              filtered.push(someNewValue);
            }
            return filtered;
          }, []),
          position: 'bottom',
          labels: {
            style: {
              colors: ['#6D788B'],
              fontSize: '9.3739px',
              fontFamily: 'Poppins',
              fontWeight: 500
            },
            offsetY: 0,
            formatter: function(value) {
              let val = '';
              if (isNaN(value)) {
                if (value.length > 13) {
                  val = value.slice(0, 10) + '..';
                } else {
                  val = value;
                }
                return val;
              } else {
                return val;
              }
            }
          },
          axisBorder: {
            show: true
          },
          axisTicks: {
            show: false
          },
          crosshairs: {
            fill: {
              type: 'gradient',
              gradient: {
                colorFrom: '#1abc9c',
                colorTo: '#1abc9c',
                stops: [0, 100],
                opacityFrom: 0.4,
                opacityTo: 0.5
              }
            }
          }
        },
        tooltip: {
          x: {
            show: true,
            formatter: function(y) {
              return y;
            }
          }
        },
        fill: {
          gradient: {
            shade: 'light',
            type: 'horizontal',
            shadeIntensity: 0.25,
            gradientToColors: undefined,
            inverseColors: true,
            opacityFrom: 1,
            opacityTo: 1,
            stops: [50, 0, 100, 100]
          }
        },
        yaxis: {
          show: true,
          tickAmount: 15,
          axisBorder: {
            show: true
          },
          axisTicks: {
            show: false
          },
          title: {
            text: 'in BIDR'
          },
          labels: {
            style: {
              colors: ['#C2C2C2'],
              fontSize: '9.3739px',
              fontFamily: 'Poppins'
            },
            show: true,
            formatter: function(val) {
              // var someNewValue = (Math.abs(option.total) / 1000000000).toFixed(
              let value = (Math.abs(val) / 1000000000).toFixed(1);
              return value;
            }
          }
        },
        title: {
          text: '',
          floating: false,
          offsetY: 320,
          align: 'center',
          style: {
            color: '#6D788B'
          }
        },
        grid: {
          show: false
        }
      };
    },
    chartOptionsStacked: function() {
      return {
        chart: {
          id: 'stackedChart',
          height: 350,
          type: 'bar',
          stacked: true,
          toolbar: {
            show: false
          }
        },
        colors: ['#66C7FF', '#4B71F0', '#FC9A27'],
        plotOptions: {
          bar: {
            borderRadius: 10,

            dataLabels: {
              position: 'top'
            }
          }
        },
        dataLabels: {
          enabled: true,
          formatter: function(val) {
            let value = (Math.abs(val) / 1000000000).toFixed(1);
            return `${value}`;
          },
          offsetY: -5,
          style: {
            fontSize: '12px',
            colors: ['#304758']
          }
        },
        xaxis: {
          categories: this.boData.reduce(function(filtered, option) {
            if (option.show) {
              var someNewValue = '';
              someNewValue = option.name;
              filtered.push(someNewValue);
            }
            return filtered;
          }, []),
          position: 'bottom',
          labels: {
            offsetY: 0,
            formatter: function(value) {
              let val = '';
              if (isNaN(value)) {
                if (value.length > 13) {
                  val = value.slice(0, 10) + '..';
                } else {
                  val = value;
                }
                return val;
              } else {
                return val;
              }
            }
          },
          axisBorder: {
            show: true
          },
          axisTicks: {
            show: false
          },
          crosshairs: {
            fill: {
              type: 'gradient',
              gradient: {
                colorFrom: '#1abc9c',
                colorTo: '#1abc9c',
                stops: [0, 100],
                opacityFrom: 0.4,
                opacityTo: 0.5
              }
            }
          }
        },
        tooltip: {
          x: {
            show: true,
            formatter: function(y) {
              return y;
            }
          }
        },
        fill: {
          gradient: {
            shade: 'light',
            type: 'horizontal',
            shadeIntensity: 0.25,
            gradientToColors: undefined,
            inverseColors: true,
            opacityFrom: 1,
            opacityTo: 1,
            stops: [50, 0, 100, 100]
          }
        },
        yaxis: {
          show: true,
          tickAmount: 15,
          axisBorder: {
            show: true
          },
          axisTicks: {
            show: false
          },
          title: {
            text: 'in BIDR'
          },
          labels: {
            show: true,
            formatter: function(val) {
              // var someNewValue = (Math.abs(option.total) / 1000000000).toFixed(
              let value = (Math.abs(val) / 1000000000).toFixed(1);
              return value;
            }
          }
        },
        title: {
          text: '',
          floating: false,
          offsetY: 320,
          align: 'center',
          style: {
            color: '#444'
          }
        },
        grid: {
          show: false
        }
      };
    },
    seriesStacked: function() {
      return [
        {
          name: 'IO',
          data: this.boData.reduce(function(filtered, option) {
            if (option.show) {
              filtered.push(option.io);
            }
            return filtered;
          }, [])
        },
        {
          name: 'PO',
          data: this.boData.reduce(function(filtered, option) {
            if (option.show) {
              filtered.push(option.po);
            }
            return filtered;
          }, [])
        },
        {
          name: 'GR',
          data: this.boData.reduce(function(filtered, option) {
            if (option.show) {
              filtered.push(option.gr);
            }
            return filtered;
          }, [])
        }
      ];
    },
    chartOptionsPillar: function() {
      return {
        chart: {
          id: 'pillarChart',
          // width: '100%',
          height: 250,
          type: 'donut'
        },
        plotOptions: {
          pie: {
            donut: {
              size: '55%'
            }
          }
        },
        legend: {
          position: 'bottom',
          horizontalAlign: 'center',
          formatter: function(seriesName, opts) {
            return [
              seriesName,
              // '-',
              opts.w.config.percent[opts.seriesIndex],
              '%'
            ];
          }
          // itemMargin: {
          //     horizontal: 10,
          //     vertical: 0
          // },
        },
        colors: ['#28A0F6', '#66C7FF', '#FA576E'],
        amount: this.pillarData.reduce(function(filtered, option) {
          if (option.show) {
            var someNewValue = (Math.abs(option.total) / 1000000000).toFixed(1);
            filtered.push(Number(someNewValue));
          }
          return filtered;
        }, []),
        series: this.pillarData.reduce(function(filtered, option) {
          if (option.show) {
            var someNewValue = (Math.abs(option.total) / 1000000000).toFixed(1);
            filtered.push(Number(someNewValue));
          }
          return filtered;
        }, []),
        percent: this.pillarPercent.reduce(function(filtered, option) {
          if (option.show) {
            var someNewValue = option.total;
            filtered.push(Number(someNewValue));
          }
          return filtered;
        }, []),
        dataLabels: {
          enabled: true,
          formatter: function(val, index) {
            return `${index.w.config.amount[index.seriesIndex]}`;
            // return (
            //   val.toFixed(0) +
            //   '% (' +
            //   `${index.w.config.amount[index.seriesIndex]}` +
            //   ')'
            // );
          },
          position: 'bottom',
          style: {
            fontSize: '12px',
            colors: ['#fff']
          }
        },
        labels: this.pillarLabel.reduce(function(filtered, option) {
          if (option.show) {
            var someNewValue = '';
            if (option.name.length > 13) {
              someNewValue = option.name.slice(0, 13) + '..';
            } else if (option.name.length <= 13) {
              someNewValue = option.name;
            }
            filtered.push(someNewValue);
          }
          return filtered;
        }, []),
        responsive: [
          {
            breakpoint: -20,
            options: {
              chart: {
                height: 250
              },
              legend: {
                position: 'bottom'
              }
            }
          }
        ]
      };
    },
    chartOptionsMethod: function() {
      return {
        chart: {
          id: 'methodChart',
          height: 250,
          type: 'donut'
        },
        plotOptions: {
          pie: {
            donut: {
              size: '55%'
            }
          }
        },
        legend: {
          position: 'bottom',
          horizontalAlign: 'center',
          formatter: function(seriesName, opts) {
            return [
              seriesName,
              ' - ',
              opts.w.config.percent[opts.seriesIndex],
              '%'
            ];
          }
        },
        colors: ['#5273E8', '#66C7FF', '#FA576E'],
        amount: this.methodData.reduce(function(filtered, option) {
          if (option.show) {
            var someNewValue = (Math.abs(option.total) / 1000000000).toFixed(1);
            filtered.push(Number(someNewValue));
          }
          return filtered;
        }, []),
        series: this.methodData.reduce(function(filtered, option) {
          if (option.show) {
            var someNewValue = (Math.abs(option.total) / 1000000000).toFixed(1);
            filtered.push(Number(someNewValue));
          }
          return filtered;
        }, []),
        percent: this.methodPercent.reduce(function(filtered, option) {
          if (option.show) {
            var someNewValue = option.total;
            filtered.push(Number(someNewValue));
          }
          return filtered;
        }, []),
        dataLabels: {
          enabled: true,
          formatter: function(val, index) {
            return `${index.w.config.amount[index.seriesIndex]}`;
          },
          position: 'bottom',
          style: {
            fontSize: '12px',
            colors: ['#fff']
          }
        },
        labels: this.methodLabel.reduce(function(filtered, option) {
          if (option.show) {
            var someNewValue = '';
            if (option.name.length > 13) {
              someNewValue = option.name.slice(0, 13) + '..';
            } else if (option.name.length <= 13) {
              someNewValue = option.name;
            }
            filtered.push(someNewValue);
          }
          return filtered;
        }, []),
        responsive: [
          {
            breakpoint: 100,
            options: {
              chart: {
                height: 250
              },
              legend: {
                position: 'center'
              }
            }
          }
        ]
      };
    },
    chartOptionsCalendar: function() {
      return {
        xaxis: {
          type: 'datetime',
          min: new Date('Jan').getTime(),
          max: new Date('Dec').getTime(),
          labels: {
            format: 'MMM'
          }
        },
        chart: {
          id: 'calendarChart',
          height: '350',
          type: 'rangeBar',
          toolbar: {
            show: false
          }
        },
        colors: ['#5273E8', '#FA576E', '#66C7FF', '#FC9A27'],
        plotOptions: {
          heatmap: {
            radius: 60,
            enableShades: true
          },
          bar: {
            borderRadius: 10,

            barHeight: '30%',
            startingShape: 'rounded',

            horizontal: true
          }
        },
        grid: {
          show: true
        }
      };
    },
    seriesCalendar: function() {
      return [
        {
          data: this.dataCalendar.reduce(function(filtered, option) {
            if (option.show) {
              filtered.push(option);
            }
            return filtered;
          }, [])
        }
      ];
    }
  },
  methods: {
    getFiltered(val) {
      this.filterBy = val.info;
      this.paramFiltered = val.param;
      this.getData(this.year);
    },
    selectionChart(event, chartContext, config) {
      this.$router.push({
        params: {
          code: this.taxoData[config.dataPointIndex].code,
          year: this.year
        },
        name: 'spendingTaxo',
        data: this.year
      });
    },
    heightCalendar() {
      let length = this.dataCalendar.length;
      if (length < 10) {
        return '350';
      } else if (length > 10 && length < 50) {
        return '400';
      } else if (length > 50 && length < 100) {
        return '450';
      } else if (length > 100) {
        return 'auto';
      }
    },
    getReminderBudget() {
      let params = {
        profile_id: this.profile_id
      };
      return this.$store
        .dispatch('configuration/getReminderBudget', params)
        .then(data => {
          if (data.code === 200) {
            if (data.data.popup) {
              if (!this.$cookies.get('popupReminder')) {
                this.$cookies.set('popupReminder', 'opened', 0);
                Swal.fire('', data.data.popup, 'warning');
              }
            }
          } else {
            Swal.fire('Failed!', data.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          Swal.fire('Failed!', err.data.message.text_en, 'error');
        });
    },
    getData(year) {
      this.isLoadSummary = true;
      this.year = year;
      this.showYear = moment(year).format('YYYY');
      let date = new Date();
      if (!year) {
        year = moment(date).format('YYYY');
      }
      let params = {
        year: moment(year).format('YYYY'),
        filter: this.paramFiltered
      };
      return this.$store
        .dispatch('dashboard/getAll', params)
        .then(data => {
          if (data.code === 200) {
            this.isLoadSummary = false;
            this.item = data.data;
            this.getPercentage(this.year);
            if (this.filter === 'Budget Owner') {
              this.getStackedChart(this.year);
            } else {
              this.getChartBar(this.year);
            }
            // kalau summary lebih dari 12 digit font style jadi kecil
            var editCSS = document.createElement('style');
            var editCSSCur = document.createElement('style');
            let budget = this.currFormatter(this.item.totalBudget);
            let po = this.currFormatter(this.item.totalPO);
            let spending = this.currFormatter(this.item.totalSpending);
            let gr = this.currFormatter(this.item.totalGR);
            if (
              (budget && budget.length > 5) ||
              (po && po.length > 5) ||
              (spending && spending.length > 5) ||
              (gr && gr.length > 5)
            ) {
              editCSS.innerHTML = '.total {font-size: 22px !important;}';
              document.body.appendChild(editCSS);
              editCSSCur.innerHTML = '.curr {font-size: 22px !important;}';
              document.body.appendChild(editCSSCur);
            } else {
              editCSS.innerHTML = '.total {font-size: 25px !important;}';
              document.body.appendChild(editCSS);
              editCSSCur.innerHTML = '.curr {font-size: 25px !important;}';
              document.body.appendChild(editCSSCur);
            }
          } else {
            this.isLoadSummary = false;
            Swal.fire('Failed!', data.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          this.isLoadSummary = false;
          Swal.fire('Failed!', err.data.message.text_en, 'error');
        });
    },
    currFormatter(num) {
      if (num < 0) {
        return '(' + (Math.abs(num) / 1000000000).toFixed(1) + ')';
      } else if (num > 0) {
        return (Math.abs(num) / 1000000000).toFixed(1);
      }
    },
    changeFilter(year, itemFilter) {
      !itemFilter
        ? this.getChartBar(year, itemFilter)
        : itemFilter.value === 'budget_owner'
        ? this.getStackedChart(year)
        : this.getChartBar(year, itemFilter);
    },
    getChartBar(year, itemFilter) {
      this.isLoadChartBar = true;
      this.year = year;

      let date = new Date();
      if (!year) {
        year = moment(date).format('YYYY');
      }
      let group = '';
      if (!itemFilter) {
        if (this.filter === 'Taxonomy') {
          group = 'taxo';
        } else {
          group = 'cost_center';
        }
      } else {
        this.filter = itemFilter.name;
        group = itemFilter.value;
      }
      let params = {
        year: moment(year).format('YYYY'),
        filter: this.paramFiltered,
        groupBy: group
      };
      return this.$store
        .dispatch('dashboard/getChart', params)
        .then(data => {
          if (data.code === 200) {
            this.isLoadChartBar = false;
            this.getQuarter(this.year);
            this.taxoLabel = [];
            this.legendChart = [];
            this.taxoData = data.data.chartData;
            data.data.chartData.map(item => {
              this.taxoLabel.push({
                name: item.name,
                show: true
              });
              this.legendChart.push({
                name: item.name,
                show: true
              });
            });
            this.taxoData = data.data.chartData.map(item => {
              return {
                code: item.code,
                total: item.total,
                po: item.po,
                gr: item.gr,
                show: true
              };
              // return item.total;
            });
            this.pillarLabel = data.data.pillars.map(item => {
              return {
                name:
                  item.pillars.charAt(0).toUpperCase() +
                  item.pillars.substring(1),
                show: true
              };
            });
            this.pillarData = data.data.pillars.map(item => {
              return {
                total: item.count,
                show: true
              };
            });
            this.pillarPercent = data.data.pillars.map(item => {
              return {
                total: item.percentage,
                show: true
              };
            });
            this.legendPillar = data.data.pillars.map(item => {
              return {
                name:
                  item.pillars.charAt(0).toUpperCase() +
                  item.pillars.substring(1),
                show: true
              };
            });
            this.methodLabel = data.data.method.map(item => {
              return {
                name:
                  item.method.charAt(0).toUpperCase() +
                  item.method.substring(1),
                show: true
              };
            });
            this.methodData = data.data.method.map(item => {
              return {
                total: item.count,
                show: true
              };
            });
            this.methodPercent = data.data.method.map(item => {
              return {
                total: item.percentage,
                show: true
              };
            });
            this.legendMethod = data.data.method.map(item => {
              return {
                name:
                  item.method.charAt(0).toUpperCase() +
                  item.method.substring(1),
                show: true
              };
            });
          } else {
            this.isLoadChartBar = false;
            Swal.fire('Failed!', data.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          this.isLoadChartBar = false;
          Swal.fire('Failed!', err.data.message.text_en, 'error');
        });
      // }
    },
    getQuarter(year) {
      this.isLoadQuarter = true;
      this.year = year;

      let date = new Date();
      if (!year) {
        year = moment(date).format('YYYY');
      }
      let params = {
        year: moment(year).format('YYYY'),
        filter: this.paramFiltered
      };
      return this.$store
        .dispatch('dashboard/getQuarter', params)
        .then(data => {
          this.isLoadQuarter = false;
          if (data.code === 200) {
            // this.getCalendar();
            this.getHighlightActive();
            this.quarterData = [];
            this.quarterLabel = [];
            this.legendQuarter = [];
            this.quarterPercent = [];
            data.data.map(item => {
              this.quarterLabel.push({
                name: item.name,
                show: true
              });
              this.legendQuarter.push({
                name: item.name,
                show: true
              });
              this.quarterData.push({
                name: item.amount,
                show: true
              });
              this.quarterPercent.push({
                name: item.percent,
                show: true
              });
            });
          } else {
            Swal.fire('Failed!', data.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          this.isLoadQuarter = false;
          Swal.fire('Failed!', err.data.message.text_en, 'error');
        });
    },
    getPercentage(year) {
      this.isLoadSummary = true;
      this.year = year;
      let date = new Date();
      if (!year) {
        year = moment(date).format('YYYY');
      }
      let params = {
        year: moment(year).format('YYYY'),
        filter: this.paramFiltered
      };
      return this.$store
        .dispatch('dashboard/getPercentage', params)
        .then(data => {
          if (data.code === 200) {
            this.isLoadSummary = false;
            this.itemPercent = data.data;
            this.itemPercent.spending.percentage = this.itemPercent.spending
              .percentage
              ? this.itemPercent.spending.percentage
              : 0;
            this.itemPercent.po.percentage = this.itemPercent.po.percentage
              ? this.itemPercent.po.percentage
              : 0;
            this.itemPercent.gr.percentage = this.itemPercent.gr.percentage
              ? this.itemPercent.gr.percentage
              : 0;
          } else {
            this.isLoadSummary = false;
            Swal.fire('Failed!', data.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          this.isLoadSummary = false;
          Swal.fire('Failed!', err.data.message.text_en, 'error');
        });
    },
    // getCalendar(filter) {
    //   this.progressDialogLoading = true;
    //   let category = '';
    //   if (!filter) {
    //     if (this.filterCalendar === 'Taxonomy') {
    //       category = 'taxo';
    //     } else {
    //       category = 'cost_center';
    //     }
    //   } else {
    //     this.filterCalendar = filter.name;
    //     category = filter.value;
    //   }
    //   let params = {
    //     year: moment(this.year).format('YYYY'),
    //     category: category,
    //     divisi_ids: this.divisionFil,
    //     house_ids: this.houseFil,
    //     dept_ids: this.deptFil,
    //     bo_ids: this.boFil
    //   };
    //   return this.$store
    //     .dispatch('dashboard/getCalendar', params)
    //     .then(data => {
    //       this.progressDialogLoading = false;
    //       if (data.code === 200) {
    //         this.getHighlightActive();
    //         let tempColor = [];
    //         this.dataCalendar = data.data.map((item, index) => {
    //           let color = this.colors[
    //             Math.floor(Math.random() * this.colors.length)
    //           ];
    //           let fillColor = '';
    //           if (item.field === data.data[index].field) {
    //             if (index > 0) {
    //               if (item.field === data.data[index - 1].field) {
    //                 color = tempColor[index - 1];
    //                 tempColor.push(color);
    //                 fillColor = tempColor[index];
    //               } else {
    //                 tempColor.push(color);
    //                 fillColor = tempColor[index];
    //               }
    //             } else {
    //               tempColor.push(color);
    //               fillColor = tempColor[index];
    //             }
    //           }
    //           return {
    //             x: item.field,
    //             y: item.date.map(val => {
    //               return new Date(val).getTime();
    //             }),
    //             fillColor: fillColor,
    //             show: true
    //           };
    //         });
    //         this.labelCalendar = data.data.map(item => {
    //           return {
    //             name: item.field,
    //             show: true
    //           };
    //         });
    //       } else {
    //         Swal.fire('Failed!', data.data.message.text_en, 'error');
    //       }
    //     })
    //     .catch(err => {
    //       this.progressDialogLoading = false;
    //       Swal.fire('Failed!', err.data.message.text_en, 'error');
    //     });
    // },
    getHighlightActive() {
      this.isLoadHightlight = true;
      let newDate = new Date();
      let params = {
        date: moment(newDate).format('YYYY-MM-DD'),
        profile_id: this.profile_id
      };
      return this.$store
        .dispatch('keyHighlight/getActive', params)
        .then(data => {
          this.loading = false;
          if (data.code === 200) {
            this.isLoadHightlight = false;
            this.getHighlightSystemActive();
            this.key_highlight = data.data.map(item => {
              let date = item.start;
              return {
                ...item,
                date: date
              };
            });
          } else {
            this.isLoadHightlight = false;
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          this.isLoadHightlight = false;
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
        });
    },
    getHighlightSystemActive() {
      this.isLoadHightlight = true;
      let newDate = new Date();

      let params = {
        profile_id: this.profile_id,
        year: moment(newDate).format('YYYY')
      };
      return this.$store
        .dispatch('keyHighlight/geSystemtActive', params)
        .then(data => {
          this.isLoadHightlight = false;
          if (data.code === 200) {
            this.keyHighlightSystem = data.data;
          } else {
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          this.isLoadHightlight = false;
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
        });
    },
    async hideData(label, index) {
      this.legendChart[index].show = !this.legendChart[index].show;
      this.taxoData[index].show = this.legendChart[index].show;
      this.taxoLabel[index].show = this.legendChart[index].show;
      ApexCharts.exec('taxoChart', 'updateOptions', {
        xaxis: {
          categories: this.taxoLabel.reduce(function(filtered, option) {
            if (option.show) {
              var someNewValue = option.name;
              filtered.push(someNewValue);
            }
            return filtered;
          }, [])
        }
      });
      ApexCharts.exec('taxoChart', 'updateSeries', [
        {
          data: this.taxoData.reduce(function(filtered, option) {
            if (option.show) {
              var someNewValue = option.name;
              filtered.push(someNewValue);
            }
            return filtered;
          }, [])
        }
      ]);
    },
    async hideDataStacked(label, index) {
      this.boData[index].show = !this.boData[index].show;
      ApexCharts.exec('stackedChart', 'updateOptions', {
        xaxis: {
          categories: this.boData.reduce(function(filtered, option) {
            if (option.show) {
              var someNewValue = option.name;
              filtered.push(someNewValue);
            }
            return filtered;
          }, [])
        }
      });
    },
    async hideDataQuarter(label, index) {
      this.legendQuarter[index].show = !this.legendQuarter[index].show;
      this.quarterData[index].show = this.legendQuarter[index].show;
      this.quarterLabel[index].show = this.legendQuarter[index].show;
      ApexCharts.exec('quarterChart', 'updateOptions', {
        xaxis: {
          categories: this.quarterLabel.reduce(function(filtered, option) {
            if (option.show) {
              var someNewValue = option.name;
              filtered.push(someNewValue.toUpperCase());
            }
            return filtered;
          }, [])
        }
      });
      ApexCharts.exec('quarterChart', 'updateSeries', [
        {
          data: this.quarterData.reduce(function(filtered, option) {
            if (option.show) {
              var someNewValue = option.name;
              filtered.push(someNewValue);
            }
            return filtered;
          }, [])
        }
      ]);
    },
    async hideDataPillar(label, index) {
      this.legendPillar[index].show = !this.legendPillar[index].show;
      this.pillarData[index].show = this.legendPillar[index].show;
      this.pillarLabel[index].show = this.legendPillar[index].show;
      ApexCharts.exec('pillarChart', 'updateOptions', {
        xaxis: {
          categories: this.pillarLabel.reduce(function(filtered, option) {
            if (option.show) {
              var someNewValue = option.name;
              filtered.push(someNewValue);
            }
            return filtered;
          }, [])
        }
      });
      ApexCharts.exec('pillarChart', 'updateSeries', [
        {
          data: this.pillarData.reduce(function(filtered, option) {
            if (option.show) {
              var someNewValue = option.total;
              filtered.push(Number(someNewValue));
            }
            return filtered;
          }, [])
        }
      ]);
    },
    async hideDataMethod(label, index) {
      this.legendMethod[index].show = !this.legendMethod[index].show;
      this.methodData[index].show = this.legendMethod[index].show;
      this.methodLabel[index].show = this.legendMethod[index].show;
      ApexCharts.exec('methodChart', 'updateOptions', {
        xaxis: {
          categories: this.methodLabel.reduce(function(filtered, option) {
            if (option.show) {
              var someNewValue = option.name;
              filtered.push(someNewValue);
            }
            return filtered;
          }, [])
        }
      });
      ApexCharts.exec('methodChart', 'updateSeries', [
        {
          data: this.methodData.reduce(function(filtered, option) {
            if (option.show) {
              var someNewValue = option.total;
              filtered.push(Number(someNewValue));
            }
            return filtered;
          }, [])
        }
      ]);
    },
    async hideDataCalendar(label, index) {
      this.labelCalendar[index].show = !this.labelCalendar[index].show;
      this.dataCalendar[index].show = !this.dataCalendar[index].show;
    },
    getStackedChart(year) {
      this.isLoadStackedChart = true;
      this.year = year;
      let date = new Date();
      this.filter = 'Budget Owner';
      if (!year) {
        year = moment(date).format('YYYY');
      }
      let params = {
        year: moment(year).format('YYYY'),
        filter: this.paramFiltered
      };
      this.$store
        .dispatch('dashboard/getDashboardBo', params)
        .then(data => {
          this.isLoadStackedChart = false;
          if (data.code === 200) {
            this.getQuarter(this.year);
            this.boData = data.data.map(item => {
              return {
                name: item.budgetOwner.desc,
                io: item.io,
                po: item.po,
                gr: item.gr,
                show: true
              };
            });
          } else {
            this.isLoadStackedChart = false;
            Swal.fire('Failed!', data.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          this.isLoadStackedChart = false;
          Swal.fire('Failed!', err.data.message.text_en, 'error');
        });
    }
  }
};
</script>

<style>
.filterby-info .v-expansion-panel-header__icon {
  margin-left: 0px !important;
}
.drawer-menu--scroll--vert {
  /* max-width: 700px; */
  overflow: auto;
}
.text-strike {
  text-decoration: line-through;
}
.v-text-field__details {
  min-height: 5px !important;
}
.timeline {
  margin-left: 175px;
}
.timeline-calendar {
  background: #dedede;
  height: 2.5px;
  margin-top: 10px;
  margin-bottom: 20px;
}
.timeline .q1 {
  margin-right: 7%;
}
.timeline .q2 {
  margin-right: 8.9%;
}
.timeline .q3 {
  margin-right: 8.4%;
}
.timeline .timeline-calendar ul {
  padding-left: 0 !important;
}
.timeline .timeline-calendar li {
  list-style: none;
  margin-top: -10%;
  background: #28a0f6;
  color: #fff;
  width: 33px;
  height: 33px;
  border-radius: 50%;
  margin-left: 50%;
  transform: translateX(-50%);
}
.timeline .timeline-calendar li span {
  line-height: 31px !important;
  font-size: 12px;
  font-weight: bold;
  font-size: 12px;
  text-align: center;
  letter-spacing: -0.02em;
}
.circle-icon {
  background: #fc8027;
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
}
.circle-icon-2 {
  background: #00b5b8;
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
}
.divider-small {
  max-width: calc(100% - 52px) !important;
  margin-left: 52px !important;
}
.title-comingsoon {
  position: absolute;
  left: 50%;
  top: 57%;
  transform: translate(-50%, -50%);
}
</style>
